export const Data =  [
  {
    id:1011,
    img: "./images/discount/discount-1.png",
    name: "BenuX 2022",
    price: 250,
    quantity:1,
  },
  {
    id:1012,
    img: "./images/discount/discount-2.png",
    name: "Sony TV ",
    price: 450,
    quantity:1,
  },
  {
    id:1013,
    img: "./images/discount/discount-3.png",
    name: "Sony PS4",
    price: 50,
    quantity:1,
  },
  {
    id:1014,
    img: "./images/discount/discount-4.png",
    name: "Setg 2022",
    price: 100,
    quantity:1,
  },
  {
    id:1015,
    img: "./images/discount/discount-5.png",
    name: "Tony BGB",
    price: 20,
    quantity:1,
  },
  {
    id:1016,
    img: "./images/discount/discount-6.png",
    name: "RG prodts",
    price: 200,
    quantity:1,
  },
  {
    id:1017,
    img: "./images/discount/discount-7.png",
    name: "Ranasonic",
    price: 300,
    quantity:1,
  },
  {
    id:1018,
    img: "./images/discount/discount-8.png",
    name: "Pune HD",
    price: 30,
    quantity:1,
 
  },
  {
    id:1019,
    img: "./images/discount/discount-9.png",
    name: "Sony CCTV",
    price: 80,
    quantity:1,
  },
  ]


